import { Component, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { KPI } from '../../../@core/api';

@Component({
  template: '',
  styleUrls: [],
})
export abstract class BaseHistoryDialogComponent implements OnDestroy {
  public history: KPI.History;
  public error: boolean = false;
  public loading: boolean = false;

  protected subscriptions: Subscription[] = [];

  constructor(
  ) {
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public abstract close(): void;
}
